export default "__VITE_ASSET__Dgbpxp1D__"